import { JSX } from 'react';
import Image from '../Image/Image';

interface AvatarPros {
  height: string;
  width: string;
  url: string;
  altText: string;
}

const Avatar = ({ url, height, width, altText }: AvatarPros): JSX.Element => {
  return (
    <Image alt={altText} src={url} height={height} width={width} />
  );
};

export default Avatar;